import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_raster_download_stepper = _resolveComponent("raster-download-stepper")!
  const _component_dataset_wrapper = _resolveComponent("dataset-wrapper")!

  return (_openBlock(), _createBlock(_component_dataset_wrapper, {
    type: _ctx.defaultDatasetType,
    mode: _ctx.mode,
    "resource-id": _ctx.resourceId
  }, {
    default: _withCtx(() => [
      _createVNode(_component_raster_download_stepper, { "default-type": _ctx.defaultStepperType }, null, 8, ["default-type"])
    ]),
    _: 1
  }, 8, ["type", "mode", "resource-id"]))
}